import './index.less'

export default () => {
  const onTop = () => {
    window.scrollTo(0, 0)
  }
  return <div className='backtop' onClick={onTop}>
  </div>
}